import React from "react";
import MenuItem from "./MenuItem/MenuItem";
import routeData from '../../../assets/static/routes.json';
import classes from './MenuItems.module.css';

const Menu = () => {
	let routes = routeData.routes;
	return (
		<ul className={classes.MenuItems}>
			{routes.map(route => (
				<MenuItem
					key={route.id}
					link={route.link}
					exact={true}
					icon={route.icon}
					text={route.text} />
				)
			)}
		</ul>
	)
};

export default Menu;